export default {
  spring: 'cubic-bezier(0.16, 1, 0.3, 1)',
  easeOut: 'cubic-bezier(0.0, 0.0, 0.2, 1)',
  easeIn: 'cubic-bezier(0.4, 0.0, 1, 1)',
  easeStandard: 'cubic-bezier(0.4, 0.0, 0.2, 1)'
}
